<template>
    <div class="FM_marketAccountInfo">
        <!-- 提现详情/审核 -->
        <el-dialog
                ref="terminalAudit"
                :visible="infoIsShow"
                @close="handleClose"
                :close-on-click-modal="false"
        >
            <el-card class="box-card" shadow="hover">
                <div class="title">充值信息</div>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <span class="labels">姓名：</span>
                        <span>{{dialogData.data.nickname}}</span>
                    </el-col>

                    <el-col :span="24">
                        <span class="labels">充值金额：</span>
                        <span>{{dialogData.data.money}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">凭证：</span>
                        <img width="300" height="300" v-if="imgPath" :src="imgPath" class="avatar" />

                    </el-col>
                    <el-col :span="24" v-if="dialogData.data.pass_status == 3">
                        <span class="labels">拒绝原因：</span>
                        <span>{{dialogData.data.refuse_reason}}</span>

                    </el-col>

                </el-row>
                <el-form
                        :model="auditForm"
                        label-position="top"
                        label-width="80px"
                        v-if="dialogData.isInfo != 1"
                >
                    <div class="audit">
                        <div class="title">审核</div>
                        <el-form-item>
                            <el-radio v-model="auditForm.auditRadio" :label="1">通过</el-radio>
                            <el-radio v-model="auditForm.auditRadio" :label="2">拒绝</el-radio>
                        </el-form-item>
                       <!-- <span style="color:red" v-if="auditForm.auditRadio == 2">注：拒绝后，提现金额将原路退回</span>-->
                        <el-form-item label="拒绝原因："  v-if="auditForm.auditRadio == 2">
                            <el-input
                                    maxlength="10"
                                    clearable
                                    v-model="auditForm.refuse_reason"
                                    placeholder="请输入拒绝原因"
                            ></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <div style="margin-top:20px" v-if="dialogData.isInfo != 1">
                    <el-button
                            @click="submit"
                            type="primary"
                            size="medium"
                            style="font-size:12px"
                            :loading="loading"
                    >确 定</el-button>
                </div>
            </el-card>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "FM_marketAccountInfo",
        props: {
            infoIsShow: {
                type: Boolean,
                default: false
            },
            dialogData: {
                type: Object
            }
        },
        data() {
            return {
                auditForm: {
                    auditRadio: 1,
                    auditRadio1: this.dialogData.data.wat,
                    type: 0,
                    refuse_reason:'',
                },
                imgPath: '',//data.recharge_img
                resData: {},
                loading: false
            }
        },
        mounted() {
            this.imgPath = this.dialogData.data.recharge_img;
        },
        methods: {
            submit() { //提交
                let { id, user_id,money } = this.dialogData.data;//this.auditForm.auditRadio == 2
                this.loading = true; //防重复
                this.$api.post('user/market_withdraw_audit', { id, user_id ,money,status:this.auditForm.auditRadio,refuse_reason:this.auditForm.refuse_reason}, res => {
                    if (res.code == 0) {
                        let that = this;
                        this.$message.success({
                            type: 'success',
                            message: res.msg,
                            duration: 2000,
                            onClose() {
                                that.handleClose(1);
                            }
                        });
                    } else {
                        this.$message.error(res.msg);
                        this.loading = false;
                    }
                });
            },
            typeChange(val) { //监听radio
                this.auditForm.auditRadio1 = val;
            },
            handleClose(ref) {
                this.$emit('infoClose', ref);
            }
        },
        computed: {
            status() {
                var status = '';
                switch (this.dialogData.data.status) {
                    case 0:
                        status = '未审核';
                        break;
                    case 1:
                        status = '提现成功';
                        break;
                    case 2:
                        status = '审核拒绝';
                        break;
                    case 3:
                    case 4:
                        status = '等待结果';
                        break;
                    default:
                        status = '提现失败';
                        break;
                }
                return status;
            },

        }
    };
</script>

<style lang="scss" scope>
    .FM_withdrawalInfo {
        * {
            font-size: 12px;
        }
        .labels {
            font-weight: 700;
        }
        .desc {
            border: 1px solid #d0d0d0;
            background-color: #ebeef5;
            padding: 3px;
            line-height: 20px;
            margin-top: 5px;
        }
        .title {
            margin: 10px 0;
            font-size: 13px;
            font-weight: 700;
            border-left: 5px solid #40b8ff;
            padding: 0 0 0 10px;
            .el-button--text {
                color: #303133;
                font-size: 13px;
                font-weight: 700;
            }
        }
        .el-input__inner,
        ::v-deep .el-radio__label {
            font-size: 12px;
        }
        .el-form-item {
            margin-bottom: 5px;
            ::v-deep .el-form-item__label {
                padding: 0;
                font-weight: 700;
                font-size: 12px;
            }
            ::v-deep .el-form-item__content {
                line-height: 0;
            }
        }
        ::v-deep .el-checkbox__label {
            font-size: 12px;
        }
        .el-row {
            margin: 10px 0;
            &:last-child {
                margin-bottom: 0;
            }
            .el-col {
                margin: 10px 0;
            }
        }
    }
</style>
